import type {
  RunSmartViewArtifactSourceRequest,
  SmartViewArtifactFilterValue,
} from "../../../../../api/types/smartViewArtifactsTypes";

export interface SourceReportRequest {
  version: number;
  sourceKey: string;
  filterValues: Record<string, string[]>;
  overrides: Record<string, string[]>;
}

export const toFilterValueList = (values: Record<string, string[]>): SmartViewArtifactFilterValue[] =>
  Object.entries(values).map(([key, filterValues]) => ({ key, values: filterValues }));

export const toRunSourceRequest = (request: SourceReportRequest): RunSmartViewArtifactSourceRequest => ({
  filterValuesUserInput: toFilterValueList(request.filterValues),
  overridesUserInput: toFilterValueList(request.overrides),
});

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const isFilterValueRecord = (value: unknown): value is Record<string, string[]> =>
  isRecord(value) &&
  Object.values(value).every((values) => Array.isArray(values) && values.every((item) => typeof item === "string"));

export const isSourceReportRequest = (value: unknown): value is SourceReportRequest =>
  isRecord(value) &&
  typeof value["version"] === "number" &&
  typeof value["sourceKey"] === "string" &&
  isFilterValueRecord(value["filterValues"]) &&
  isFilterValueRecord(value["overrides"]);
